module.exports = __webpack_public_path__ + "account/img/record.32e39d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/record.png
// module id = 0Sbe
// module chunks = 2 3